/* Ratings.tsx generated by @compiled/babel-plugin v0.36.0 */
import { ax, ix, CC, CS } from "@compiled/react/runtime";
import StarStarredIcon from '@atlaskit/icon/core/star-starred';
import React from 'react';
import { EMPTY_STAR, TOTAL_STARS } from './Ratings.constants';
import { AverageStars, NoRatingContainer, NoRatingText, NumericRatingStyled, RatingsContainer, RatingsCountStyled, StarIconContainer, StarRatingStyled, TotalStars } from './Ratings.styles';
import { getStarVariations, roundRatingToOneDecimal } from './Ratings.utils';
import { StarGradients } from './StarGradients';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const _ = "._syaz1fxt{color:var(--ds-text,#172b4d)}";
const RatingStyle = null;
const NumericRating = _ref => {
  let {
    avgStars,
    boldAverageStars,
    isWebCoherenceEnabled
  } = _ref;
  return /*#__PURE__*/_jsxs(NumericRatingStyled, {
    children: [/*#__PURE__*/_jsx(AverageStars, {
      isBold: boldAverageStars,
      children: avgStars
    }), /*#__PURE__*/_jsxs(CC, {
      children: [/*#__PURE__*/_jsx(CS, {
        children: [_]
      }), /*#__PURE__*/_jsxs(TotalStars, {
        className: ax([isWebCoherenceEnabled && "_syaz1fxt"]),
        children: ["/", TOTAL_STARS]
      })]
    })]
  });
};
const StarRating = _ref2 => {
  let {
    ratings,
    size = 'medium'
  } = _ref2;
  const stars = getStarVariations(ratings);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(StarGradients, {}), /*#__PURE__*/_jsx(StarRatingStyled, {
      children: stars.map((variation, index) => /*#__PURE__*/_jsx(StarIconContainer, {
        "data-testid": "star-rating-".concat(variation),
        variation: variation,
        size: size,
        children: /*#__PURE__*/_jsx(StarStarredIcon, {
          label: "Star rating",
          LEGACY_size: size,
          size: "small"
        })
      }, index))
    })]
  });
};
const RatingsCount = _ref3 => {
  let {
    numRatings,
    isWebCoherenceEnabled
  } = _ref3;
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_]
    }), /*#__PURE__*/_jsxs(RatingsCountStyled, {
      className: ax([isWebCoherenceEnabled && "_syaz1fxt"]),
      children: ["(", numRatings, ")"]
    })]
  });
};
export const NoRatingsMessage = _ref4 => {
  let {
    testId,
    size = 'medium'
  } = _ref4;
  return /*#__PURE__*/_jsxs(NoRatingContainer, {
    children: [/*#__PURE__*/_jsx(StarIconContainer, {
      "data-testid": testId,
      variation: EMPTY_STAR,
      size: size,
      children: /*#__PURE__*/_jsx(StarStarredIcon, {
        label: "No star rating yet",
        LEGACY_size: size
      })
    }), /*#__PURE__*/_jsx(NoRatingText, {
      children: "No reviews yet"
    })]
  });
};
export const Ratings = _ref5 => {
  let {
    testId,
    ratings,
    size,
    showNumberRatings = true,
    showNoRatingsMessage = false,
    boldAverageStars = false,
    isWebCoherenceEnabled = false
  } = _ref5;
  const {
    avgStars,
    numRatings
  } = ratings;
  const roundRating = roundRatingToOneDecimal(avgStars || 0);
  return /*#__PURE__*/_jsx("div", {
    role: "img",
    "data-testid": testId,
    "aria-label": "Rating of ".concat(roundRating, " out of ").concat(TOTAL_STARS, " stars based on ").concat(numRatings, " reviews"),
    children: showNoRatingsMessage && !numRatings ? /*#__PURE__*/_jsx(NoRatingsMessage, {
      testId: testId,
      size: size
    }) : /*#__PURE__*/_jsxs(RatingsContainer, {
      "aria-hidden": "true",
      children: [showNumberRatings && !!numRatings && /*#__PURE__*/_jsx(NumericRating, {
        isWebCoherenceEnabled: isWebCoherenceEnabled,
        boldAverageStars: boldAverageStars,
        avgStars: roundRating
      }), /*#__PURE__*/_jsx(StarRating, {
        ratings: ratings,
        size: size
      }), showNumberRatings && !!numRatings && /*#__PURE__*/_jsx(RatingsCount, {
        isWebCoherenceEnabled: isWebCoherenceEnabled,
        numRatings: numRatings
      })]
    })
  });
};